import { render, staticRenderFns } from "./Kabupaten.vue?vue&type=template&id=30b22c73"
import script from "./Kabupaten.vue?vue&type=script&lang=js"
export * from "./Kabupaten.vue?vue&type=script&lang=js"
import style0 from "./Kabupaten.vue?vue&type=style&index=0&id=30b22c73&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports